"use strict";

var novicell = novicell || {};
var dgv = dgv || {};


dgv.scroller = dgv.scroller || function () {

    function init() {
        // Check if carousel exists on page
        var site        = document.getElementById('js-site'),
            hero        = document.querySelector('.hero'),
            scroll_top  = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

        if (!hero) {
          return;
        }

        // If carousel exists, execute functions
        mapReveal();

        var site_header         = document.querySelector('.site-header');

        if ( site_header ) {
            var nav_links           = site_header.querySelectorAll('.site-header__menu .anchorlink'),
                site_header_height  = site_header.clientHeight,
                hero                = document.querySelector('.js-hero-hide'),
                hero_height         = hero.clientHeight,
                hero_offset         = (hero_height - site_header_height - 1) + hero.offsetTop;

            if ( site.classList.contains('site--restaurant') ) {
                anchor_current_toggle(nav_links, scroll_top, site_header_height);

                window.addEventListener('scroll', function() {
                    scroll_top = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

                    anchor_current_toggle(nav_links, scroll_top, site_header_height);
                    siteScroller(scroll_top, site_header, hero_offset);
                });
            } else {
                window.addEventListener('scroll', function() {
                    scroll_top = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

                    siteScroller(scroll_top, site_header, hero_offset);
                });
            }

            navScroller(site_header_height);
            siteScroller(scroll_top, site_header, hero_offset);
        }
    }

    function siteScroller(scroll_top, site_header, hero_offset) {
        // Nav scroller
        (scroll_top > hero_offset)
            ? site_header.classList.add('site-header--scroll-bg')
            : site_header.classList.remove('site-header--scroll-bg');
    }

    function anchor_current_toggle(nav_links, scroll_top, site_header_height) {
        nav_links.forEach(list_item => {
            var link                = list_item.querySelector('a'),
                section             = document.querySelector(link.getAttribute('href')),
                section_offsetTop   = section.offsetTop - site_header_height;

            ( section_offsetTop <= scroll_top && section_offsetTop + section.offsetHeight > scroll_top )
                ? list_item.classList.add('menu-item--active')
                : list_item.classList.remove('menu-item--active');
        });
    }

    function mapReveal() {
        var footer = document.getElementById('contact'),
            map_btn = document.getElementById('js-map-btn');

        if ( footer && map_btn ) {
            map_btn.addEventListener('click', function(e) {
                e.stopPropagation();

                if ( !footer.classList.contains('site-footer--reveal-map') ) {
                    footer.classList.add('site-footer--reveal-map');

                    anime({
                      targets: 'html,body',
                      scrollTop: document.body.scrollHeight,
                      easing: 'easeInOutQuart'
                    });

                }
            });
        }
    }

    function navScroller(header_height) {
        // Scroll To Element Smothly with Vanilla JavaScript
        let offset = 0;
        var nav_input = document.getElementById('input-toggle__site-header-nav');

        // Add Event Listener to parent Element
        document.querySelector('.site-header__menu').addEventListener('click', reply_click);

        //CallBack Function
        function reply_click() {
            var clickedTarget = event.srcElement;

            event.stopPropagation();
            event.preventDefault();
            var attribute = event.srcElement.getAttribute('href');


            if ( /(^#[^\s]*)/g.test(attribute) ) {
                var target = attribute.split('#')[1];
            } else {

                if (attribute != null){
                    window.location.href = attribute;

                }

            }

            console.log(target);
            var offset_target = document.getElementById(target);
            offset = offset_target.offsetTop - header_height;

            anime({
                targets: 'html,body',
                scrollTop: offset,
                easing: 'easeInOutQuart'
            });

            //console.log(offset);

            if ( nav_input.checked ) {
                nav_input.checked = false;
            }


        }
    }

    function hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
        // use: hasClass('element','classname')
    }

  return {
    init: init
  };

}();
